import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import componentBase from '../../../../../src/lib/component-base';
import FSFlatButton from '../../../../../src/components/lib/FSFlatButton';
import { validStatusesForDownload } from '../../home/constants';

@componentBase('ExportDataDescription')
export default class ExportDataDescription extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    downloadAsCSV: PropTypes.func,
    quoteData: PropTypes.object,
    isDataExportHistory: PropTypes.bool,
    paymentStatePast: PropTypes.bool,
    status: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.isStatusDownloadable = this.isStatusDownloadable.bind(this);
    this.shouldDisableButton = this.shouldDisableButton.bind(this);
    this.formatTotal = this.formatTotal.bind(this);
    this.renderTotals = this.renderTotals.bind(this);
    this.purchaseData = this.purchaseData.bind(this);
  }

  handleDownload = () => {
    const {
      status,
      id,
    } = this.props && this.props.quoteData;
    if (status && id) {
      if (this.validStatusForDownload(status)) {
        this.props.downloadAsCSV(id);
      }
    }
  }

  validStatusForDownload = status => status in validStatusesForDownload;

  metadata = () => (this.props.quoteData && this.props.quoteData.metadata) || {};

  codeshares = () => {
    if (this.props && this.props.quoteData) {
      const { query, metadata } = this.props.quoteData;
      if (query) {
        const { includeCodeshares } = query && query.queries;
        if (includeCodeshares && metadata) {
          const { operated, total } = metadata;
          const diff = total - operated;
          return diff > 0 ? diff : null;
        }
      }
    }
    return null;
  }

  totalsData = () => ([
    {
      title: 'Operated Flights',
      total: this.metadata().operated,
    },
    {
      title: 'Codeshares',
      total: this.codeshares(),
    },
    {
      title: 'Total Rows',
      total: this.metadata().total,
    },
  ]);

  price = () => (this.props.quoteData && this.props.quoteData.cost ? `${this.props.quoteData.cost}` : '--');

  alreadyPaidText = () => (this.props.isDataExportHistory && this.props.paymentStatePast ? '(already paid)' : '');

  isStatusDownloadable = (status) => {
    const statusWhitelist = [
      'charge_succeeded',
      'notifying',
      'notify_succeeded',
      'notify_failed',
      'download_succeeded',
    ];

    return !!statusWhitelist.find(s => s === status);
  }

  shouldDisableButton = () => {
    const { status, quoteData } = this.props;
    const actualStatus = status || (quoteData && quoteData.status);
    const disableBlacklist = ['charging', 'generating', 'charge_failed'];

    return !!disableBlacklist.find(s => s === actualStatus);
  }

  purchaseData = () => {
    // TODO: Disable button? Alert you cannot proceed until you choose what kind of data to export?
    this.props.dispatch(push('/data-exports/purchase'));
  }

  formatTotal = (title, total) => {
    if (Number.isFinite(total)) {
      return parseInt(total, 10).toLocaleString();
    }

    return '0';
  }

  renderTotals() {
    return this.totalsData().map((item, index) => {
      const { title, total } = item;
      const val = this.formatTotal(title, total);
      const key = `${title}${index}`;

      return (
        <div className='col-xs-12 col-sm-4' key={key}>
          <div className='highlights'>
            <div className='innerHighlights'>
              <h4 className='title'>{title}</h4>
              <h5 className='percentage'>{val}</h5>
            </div>
          </div>
        </div>
      );
    });
  }

  renderButton() {
    const downloadLabel = (
      <div>
        <p
          style={{
 fontSize: '16px', lineHeight: '18px', margin: 0, padding: 0,
}}
        >
          Get Your Data
        </p>
        <h4
          style={{
 fontSize: '1.2em', lineHeight: '1.3em', fontWeight: 800, margin: 0, padding: 0,
}}
        >
          DOWNLOAD
        </h4>
      </div>
    );

    if (this.props) {
      const {
        isDataExportHistory,
        paymentStatePast,
        status,
      } = this.props;

      const shouldLetDownload = this.isStatusDownloadable(status);

      if (isDataExportHistory && paymentStatePast && shouldLetDownload) {
        return (
          <FSFlatButton
            label={downloadLabel}
            onClick={this.handleDownload}
            className='downloadNowButton'
            style={FSFlatButton.style({
 lineHeight: '1px', display: 'block', margin: '15px auto', width: '75%', height: '65px', minWidth: '200px',
})}
            backgroundColor='rgb(109,216,54)'
            hoverColor='#64bc23'
          />
        );
      }
    }

    return (
      <FSFlatButton
        label='Buy NOW!'
        onClick={this.purchaseData}
        disabled={this.shouldDisableButton()}
        style={FSFlatButton.style({
 display: 'block', margin: '15px auto', width: '75%', height: '75px', minWidth: '200px',
})}
        backgroundColor='rgb(109,216,54)'
        hoverColor='#64bc23'
      />
    );
  }

  render() {
    return (
      <div className='ExportDataDescription'>
        <div className='row'>
          {this.renderTotals()}
        </div>
        <div className='costRow row'>
          <div className='col-xs-12 col-sm-4'>
            <div className='highlights specialHighlights'>
              <div className='innerHighlights'>
                <h4 className='title'>Data Export Cost</h4>
                <h5 className='percentage'>{this.price()}</h5>
                <span className='payment-state'>{this.alreadyPaidText()}</span>
              </div>
            </div>
          </div>
          <div className='col-xs-12 col-sm-6 col-sm-offset-1'>
            {this.renderButton()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/shared/ExportDataDescription/ExportDataDescription.js